<template>
    <a-card
        class="supsis-plan"
        :class="{ 'selected-plan': !editableCard && isActive(plan, currentPlansHash[plan._id]), 'supsis-plan': true }"
    >
        <div class="editable-form" v-if="editableCard">
            <div class="form-button" @click="editPlan">
                <span class="material-icons"> edit </span>
            </div>
            <div @click="deletePlan" class="form-button delete-button">
                <span class="material-icons"> delete </span>
            </div>
        </div>
        <div class="p-card-header">
            <div>
                <div class="subtitle top" :class="{ setFont: plan.isPopular }">
                    {{ plan.title }}
                </div>
                <div class="title">{{ plan.altTitle }}</div>
                <div class="subtitle price setFontPrice">
                    <div>{{ getPrice(plan, details, period) }}₺</div>
                    <div>
                        <div class="discount" v-if="getDiscount(plan) > getPrice(plan, details, period)">
                            {{ getDiscount(plan) }}₺
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-card-tag">
                <div class="popular" v-if="plan.isPopular && !isActive(plan, currentPlansHash[plan._id])">Popüler</div>
                <div
                    class="selected-plan-tag"
                    v-else-if="wizard ? isSelected : !editableCard && isActive(plan, currentPlansHash[plan._id])"
                >
                    {{ isSelected ? "Seçildi" : "Mevcut Plan" }}
                </div>
                <div class="popular" v-else-if="plan.isTrialPlan">Deneme Paketi</div>
                <div class="popular" v-else-if="editableCard">{{ plan.siteId ? "Özel Plan" : "Genel Plan" }}</div>
            </div>
        </div>

        <div class="p-card-content">
            <div v-if="plan.features">
                <p v-for="key of Object.keys(features)" :key="key">
                    <i class="fa fa-check" />
                    <template v-if="key === Features.AGENT.FREE_AGENT_COUNT">
                        {{ features[key] }} Ücretsiz Temsilci
                    </template>
                    <template v-else-if="key === Features.AGENT.AGENT_COUNT">
                        {{ features[key] < 0 ? "Sınırsız" : features[key] }} Temsilci
                    </template>
                    <template v-else-if="key === Features.CHATBOT.MAX_SESSION_COUNT">
                        {{ features[key] < 0 ? "Sınırsız" : features[key] }}
                        Chatbot
                    </template>
                    <template v-else-if="key === Features.CHATBOT.INTEGRATION_COUNT">
                        {{ features[key] < 0 ? "Sınırsız" : features[key] }} Chatbot Entegrasyon
                    </template>
                    <template v-else-if="key === Features.CHATBOT.STORY_COUNT_LIMIT">
                        {{ features[key] < 0 ? "Sınırsız" : features[key] }} Chatbot Hikaye
                    </template>
                    <template v-else-if="key === Features.CHATBOT.VERSION_HISTORY_COUNT">
                        {{ features[key] < 0 ? "Sınırsız" : features[key] }} Chatbot Sürüm Geçmişi
                    </template>
                    <template v-else-if="key === Features.CHAT.AUTO_TRANSLATION"> Otomatik Çeviri</template>
                    <template v-else-if="key === Features.CHAT.VOICE_CALLING">Sesli Arama</template>
                    <template v-else-if="key === Features.CHAT.VIDEO_CALLING">Görüntülü Arama</template>
                    <template v-else-if="key === Features.SYSTEM.DATA_PROTECT"> Veri Güvenliği</template>
                    <template v-else-if="key === Features.SYSTEM.ACCESS_ALL_AGENT">
                        Tüm Temsilciler için Erişim
                    </template>
                    <template v-else-if="key === Features.WHATSAPP.NOT_ADDITIONAL_PRICE">
                        Ek Maliyet Gerektirmez
                    </template>

                    <template v-else-if="key === Features.REPORT.REPORT">
                        {{ features[key] === "basic-report" ? "Normal Raporlama" : "Detaylı Raporlama" }}
                    </template>
                    <template v-else-if="key === Features.REPORT.VISITOR_TRACKING">Anlık Ziyaretci Takibi</template>
                    <template v-else-if="key === Features.CHAT.FILE_AND_VOICE_MESSAGE"
                        >Dosya ve Ses Kaydı Paylaşımı
                    </template>
                    <template v-else-if="key === Features.SYSTEM.TEAM_CHAT_ENTEGRATION"
                        >Takım Konuşması Entegrasyonu
                    </template>
                    <template v-else-if="key === Features.SUPPORT.SUPPORT">
                        {{ features[key] === "basic-support" ? "Standart Destek" : "7/24 Destek" }}
                    </template>
                    <template v-else-if="key === Features.SUPPORT.SOFTWARE_SUPPORT">Yazılım Desteği</template>
                    <template v-else-if="key === Features.SUPPORT.DEDICATED_CUSTOMER_SUPPORT"
                        >Özel Müşteri Desteği
                    </template>
                    <template v-else-if="key === Features.SYSTEM.CHAT_AND_NOTIFICATION">Chat ve Bildirimler</template>
                    <template v-else-if="key === Features.SYSTEM.CHAT_BALLOON_CUSTOMIZATION"
                        >Sohbet Balonu Özeleştirme
                    </template>
                    <template v-else-if="key === Features.SYSTEM.REMOVE_SUPSIS_LOGO"> Supsis Logo Kaldırma</template>
                    <template v-else-if="key === Features.SYSTEM.DATABASE_CONNECTION">
                        İzole Veritabanı Bağlantısı
                    </template>
                    <template v-else-if="key === Features.SYSTEM.SINGLE_PANEL_ACCESS"> Tek Panelden Yönetim</template>
                    <template v-else-if="key === Features.SYSTEM.MAX_DISK_SIZE">
                        {{ features[key] < 0 ? "Sınırsız" : `${features[key] / 1024 / 1024 / 1024}GB` }} Depolama
                    </template>
                    <template v-else-if="key === Features.SYSTEM.TICKET_SYSTEM">Ticket Sistemi</template>
                    <template v-else-if="key === Features.SYSTEM.WHATSAPP_ENTEGRATION">
                        Whatsapp Entegrasyonu
                    </template>
                    <template v-else-if="key === Features.SYSTEM.INSTAGRAM_ENTEGRATION">
                        Instagram Entegrasyonu
                    </template>
                    <template v-else-if="key === Features.SYSTEM.MESSENGER_ENTEGRATION">
                        Messenger Entegrasyonu
                    </template>
                    <template v-else-if="key === Features.SYSTEM.TELEGRAM_ENTEGRATION">
                        Telegram Entegrasyonu
                    </template>
                    <template v-else-if="key === Features.TRIGGERS.MAX_TRIGGER_COUNT">
                        {{ features[key] < 0 ? "Sınırsız" : features[key] }}
                        Akıllı Tetikleyici
                    </template>
                    <template v-else-if="key === Features.WHATSAPP.BROADCAST_PER_MESSAGE">
                        {{ features[key] < 0 ? "Mesaj Başına Ek Ücret" : `${features[key]}₺ Toplu Mesaj Başına` }}
                    </template>
                    <template v-else-if="key === Features.WHATSAPP.BULK_MESSAGE_SENDING"
                        >Toplu Mesaj Gönderme
                    </template>
                    <template v-else-if="key === Features.WHATSAPP.MESSAGE_UNREGISTERED_NUMBERS">
                        Kayıtlı Olmayan Numaralara Mesajlaşma
                    </template>
                    <template v-else-if="key === Features.WHATSAPP.PERSONALIZED_BROADCAST_MESSAGE">
                        Kişiselleştirilmiş Yayın Mesajı
                    </template>
                    <template v-else-if="key === Features.CHATBOT.CHATBOT_BUTTON_ACTIVITY"
                        >Otomatik Düğme / Chatbot
                    </template>
                    <template v-else-if="key === Features.SYSTEM.CHATBOT_ENTEGRATION">Chatbot Entegrasyonu</template>
                    <template v-else-if="key === Features.WHATSAPP.CONTROL_WHATSAPP">Whatsapp Yönetimi</template>
                    <template v-else-if="key === Features.SYSTEM.VISITOR_START_CHAT">Ziyaretci Chat Başlatma</template>
                    <template v-else-if="key === Features.SYSTEM.MAIL_ENTEGRATION">Mail Entegrasyonu</template>
                    <template v-else-if="key === Features.SYSTEM.SMS_ENTEGRATION">SMS Entegrasyonu</template>
                    <template v-else-if="key === Features.ARCHIVE.CHAT_ARCHIVE_TIME">
                        {{ features[key] < 0 ? "Sınırsız" : `${features[key] / 7} Hafta` }} Arşiv
                    </template>
                    <template v-else-if="key === Features.CHATBOT.ACTIVE_CHATBOT_LIMIT">
                        {{ features[key] < 0 ? "Sınırsız" : `${features[key]}` }} Aktif ChatBot
                    </template>
                    <template v-else-if="key === Features.SYSTEM.READY_CONTENTS"> Hazır İçerikler</template>
                    <template v-else-if="key === Features.SYSTEM.ALL_ENTEGRATION">Tüm Entegrasyonlar</template>
                    <template v-else-if="key === Features.SYSTEM.WEBHOOK_ENTEGRATION"> WebHook Entegrasyonu</template>
                    <template v-else-if="key === Features.SYSTEM.CALENDER_ENTEGRATION"> Takvim Entegrasyonu</template>
                    <template v-else-if="key === Features.SYSTEM.TASK_MANAGEMENT_ENTEGRATION"> Task Yönetimi</template>
                    <template v-else-if="key === Features.SYSTEM.AUTO_REZERVATION"> Otomatik Rezervasyon</template>
                    <template v-else-if="key === Features.SYSTEM.FLEXIBLE_BILLING"> Esnek Faturalandırma</template>
                    <template v-else-if="key === Features.CHAT.COPILOT"> Yapay Zekalı Asistan</template>
                    <template v-else-if="key === Features.REPORT.SPECIAL_REPORT"> Özel Raporlama</template>
                    <template v-else-if="key === Features.SYSTEM.PERMISSION_CONTROL"> Yetkilendirme Özelliği</template>
                    <template v-else-if="key === Features.WHATSAPP.CHANNEL_COUNT">
                        {{ `${features[key]}` }} Whatsapp Kanalı
                    </template>
                    <template v-else-if="key === Features.WHATSAPP.BUSINESS_CHANNEL_COUNT">
                        {{ `${features[key]}` }} Whatsapp Business Kanalı
                    </template>
                </p>
            </div>
        </div>
        <div
            v-if="!isRequireCodes() && !editableCard"
            class="subscription-button"
            :class="{ disabled: !isUpgrade().enabled, selected: isActive() }"
            @click="onClick"
        >
            {{ this.getButtonText() }}
        </div>
        <CodeInput
            :disabled="isDisabledCode()"
            v-if="!isAdmin && isRequireCodes() && !editableCard"
            v-model="couponCode"
            @confirm="applyCouponCode"
        />
    </a-card>
</template>

<script>
import { mapState } from "vuex";
import log2 from "../../utils/log2";
import { Features } from "./feature-items";
import CodeInput from "./CodeInput.vue";
import _ from "lodash";

const log = log2("Card");
export default {
    name: "Card",
    components: {
        CodeInput,
    },
    props: {
        plan: {
            type: Object,
            default: {},
        },
        period: {
            type: String,
            required: false,
            default: "monthly",
        },
        details: {
            type: Object,
            default: () => ({
                agentCount: 1,
                whatsappChannel: 1,
            }),
        },
        editableCard: {
            type: Boolean,
            default: false,
        },
        wizard: {
            type: Boolean,
            default: false,
        },
        isSelected: {
            type: Boolean,
            default: false,
        },
        appsumoCoupons: {
            type: Array,
            default: () => [],
        },
        currentPlans: {
            type: Array,
            default: () => [],
        },
        plans: {
            type: Array,
            default: () => [],
        },
        isAdmin: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState({
            systemLanguages: (state) => state.setting.settings.systemLanguages,
            site: (state) => state.site.site,
            activeUserCount: (state) => state.user.activeUserCount,
            channels: (state) => state.channel.channels,
            siteFeatures: (state) => state.site.features,
            conversationStatistics: (state) =>
                state.site.conversationStatistics.reduce(
                    (acc, usage) => {
                        acc.chatbotUsage += usage.chatbotUsage;
                        return acc;
                    },
                    {
                        chatbotUsage: 0,
                    }
                ),
        }),
    },
    data() {
        return {
            currentPlansHash: {},
            currentPlan: {},
            features: {},
            couponCode: null,
            Features,
        };
    },
    mounted() {
        this.initData();
        this.features = this.getPlanFeatures();
        this.couponCode = !this.editableCard && this.appsumoCoupons[this.plan.requiredCodes - 1]?.code;
    },
    methods: {
        onClick() {
            if (!this.isUpgrade().enabled) return;
            if (this.isActive()) {
                this.unsubscribe(this.plan);
            } else {
                this.subscribe(this.plan);
            }
        },
        initData() {
            if (!this.wizard) {
                this.currentPlansHash = this.currentPlans.reduce((acc, planAction) => {
                    acc[planAction.planId] = planAction;
                    return acc;
                }, {});
                this.currentPlan = this.plans
                    .filter((plan) => plan.type === (this.plan && this.plan.type))
                    .find((plan) => this.currentPlansHash[plan._id]);
            }
        },
        isRequireCodes() {
            return this.plan.requiredCodes || 0 > 0;
        },
        isDisabledCode() {
            const appsumoCoupons = (this.appsumoCoupons || []).length;
            return appsumoCoupons === this.plan.requiredCodes
                ? true
                : appsumoCoupons + 1 === this.plan.requiredCodes
                ? false
                : true;
        },
        getButtonText() {
            if (this.wizard && this.isSelected) {
                return "İptal Et";
            } else if (!this.wizard && this.isActive(this.plan, this.currentPlansHash[this.plan._id])) {
                const isEnabled = this.currentPlansHash[this.plan._id].enabled;
                return isEnabled ? "İptal Et" : "Devam Et";
            } else if (!this.wizard && this.plan?.partnerKey?.toLowerCase() === "appsumo") {
                const appsumoCoupons = (this.appsumoCoupons || []).length;
                return appsumoCoupons === this.plan.requiredCodes
                    ? "Aktif Plan"
                    : appsumoCoupons + 1 === this.plan.requiredCodes
                    ? "Aktif Et"
                    : "Geçiş Yapılamaz";
            } else if (!this.wizard && !this.isAdmin && !this.isUpgrade().enabled) {
                return "Geçiş Yapılamaz";
            } else {
                return "Plan Seç";
            }
        },
        getPlanFeatures() {
            const features = this.plan.features.reduce((acc, feature) => {
                const featureItems = Object.keys(feature).reduce((acc, item) => {
                    if (item !== "type") {
                        acc[item] = feature[item];
                    }
                    return acc;
                }, {});
                acc = { ...acc, ...featureItems };
                return acc;
            }, {});

            const orderedFeatures = Object.keys(features).reduce(
                (acc, feature) => {
                    acc[feature] = features[feature];
                    return acc;
                },
                {
                    agentCount: null,
                    maxTriggerCount: null,
                    freeAgentCount: null,
                    channelCount: null,
                    businessChannelCount: null,
                    chatArchiveTime: null,
                    report: null,
                    visitorTracking: null,
                    voiceCalling: null,
                    videoCalling: null,
                    fileAndVoiceMessage: null,
                    chatAndNotification: null,
                    maxDiskSize: null,
                    chatBalloonCustomization: null,
                    support: null,
                    dedicatedCustomerSupport: null,
                    readyContents: null,
                    autoTranslation: null,
                    permissionControl: null,
                    removeSupsisLogo: null,
                    allEntegrations: null,
                    chatbotEntegration: null,
                    whatsappEntegration: null,
                    instagramEntegration: null,
                    messengerEntegration: null,
                    webhookEntegration: null,
                    telegramEntegration: null,
                    smsEntegration: null,
                    ticketSystem: null,
                    chatCopilot: null,
                    visitorStartChat: null,
                    teamChatEntegration: null,
                    taskManagementEntegration: null,
                    specialReport: null,
                    calenderEntegration: null,
                    softwareSupport: null,
                    mailEntegration: null,
                    autoRezervation: null,
                    flexibleBilling: null,
                    maxSessionCount: null,
                    activeChatbotLimit: null,
                    storyCountLimit: null,
                    integrationCount: null,
                    versionHistoryCount: null,
                    chatbotButtonActivity: null,
                    maxChatArchiveTime: null,
                    databaseConnection: null,
                    singlePanelAccess: null,
                    accessAllAgent: null,
                    dataProtect: null,
                    broadcastPerMessage: null,
                    bulkMessageSending: null,
                    messageUnregisteredNumbers: null,
                    personalizedBroadcastMessage: null,
                    controlWhatsapp: null,
                    whatsappChatbotEntegration: null,
                    notAdditionalPrice: null,
                }
            );
            return Object.keys(orderedFeatures)
                .filter((feature) => {
                    return (
                        (typeof orderedFeatures[feature] == "number" ? orderedFeatures[feature] !== 0 : true) &&
                        orderedFeatures[feature]
                    );
                })
                .reduce((acc, feature) => {
                    acc[feature] = orderedFeatures[feature];
                    return acc;
                }, {});
        },
        subscribe(plan) {
            let payload = { planId: plan._id, period: this.period, isFreePlan: plan.isFreePlan };
            if (plan.type === "supsis") {
                payload.details = {
                    agentCount: plan.isFreePlan ? 1 : this.details.agentCount,
                };
            } else if (plan.type === "whatsapp" || plan.type === "whatsapp-business") {
                payload.details = {
                    whatsappChannel: this.details.whatsappChannel,
                };
            }
            const price = this.getPrice(plan, payload?.details, this.period);
            const oldPrice = this.getDiscount(plan);
            this.$emit("subscribe", {
                ...payload,
                price: oldPrice,
                discount: Math.max(oldPrice - price, 0),
                couponCode: this.couponCode,
            });
        },
        unsubscribe(plan) {
            this.$emit("unsubscribe", {
                planId: plan._id,
                planType: plan.dynamicType || plan.type,
            });
        },
        /*
         * @1 Aylıklarda Yeni Paket, Eski Pakete geçiş yapılırken kısıtlama yok
         * @2 Anlık Ödemelerde Yeni Paket, Eski paketen üst period'da olmalı yada aynı perioda olup kendinden yüksek paketi alabilir.
         * @3 Supsis Paketi ise bir pakete geçiş yaparken eğer temilci sayısı yüksek ve eşit ise geçiş yapabilir
         * @4 Whatsapp / Whatsapp Business ise bir pakete geçiş yaparken kanal sayısı eşit veya yüksek ise geçiş yapabilir.
         * @5 APPSUMO Paketti ise kaç tane doğru kodu varsa o şekilde diğer üst modele geçiş yapabilir 2. paketi aktif etmeden 3. paketi aktif edemez.
         * @6 Paket neden yükseltilmediğini tooltip olarak buttonun üstünde göstermemiz gerekli.
         * */

        isUpgrade() {
            const periods = ["monthly", "monthly-3", "monthly-6", "annual"];
            const currentPlanAction = this.currentPlansHash[this.currentPlan?._id];
            const wpChannels = this.channels.filter((channel) => ["whatsapp-qr", "whatsapp-v2"].includes(channel.type));
            const businessChannels = this.channels.filter((channel) => channel.type === "whatsapp-business-api");
            //const isAppsumoPackage = this.plan.partnerKey === "appsumo";

            const planRules = {
                supsis: () => {
                    let oldAgentCount = currentPlanAction?.details?.agentCount || 0;
                    if (this.currentPlan?.isTeamPlan) {
                        const currentPlanFeature = this.currentPlan.features.find((f) => f.type === "agent");
                        if (currentPlanFeature) oldAgentCount = currentPlanFeature.agentCount;
                    }
                    const featureAgentCount = this.features.agentCount || 0;
                    const newAgentCount = this.plan?.isTeamPlan ? featureAgentCount : this.details.agentCount;
                    return this.activeUserCount <= this.siteFeatures.maxAgentCount + (newAgentCount - oldAgentCount);
                },
                whatsapp: () => {
                    const oldChannelsCount = currentPlanAction?.details?.whatsappChannel || 0;
                    const newChannelsCount = this.details.whatsappChannel;
                    return (
                        wpChannels.length <=
                        this.siteFeatures.maxWhatsappChannel + (newChannelsCount - oldChannelsCount)
                    );
                },
                "whatsapp-business": () => {
                    const oldChannelsCount = currentPlanAction?.details?.whatsappChannel || 0;
                    const newChannelsCount = this.details.whatsappChannel;
                    return (
                        businessChannels.length <=
                        this.siteFeatures.maxBusinessWhatsappChannel + (newChannelsCount - oldChannelsCount)
                    );
                },
                chatbot: () => {
                    const oldPlanFeatures =
                        (this.currentPlan?.features || []).find((f) => f.type === "chatbot")?.maxSessionCount || 0;
                    const newPlanFeatures = this.features.maxSessionCount || 0;

                    return (
                        this.conversationStatistics.chatbotUsage <=
                        this.siteFeatures.maxSessionCount + (newPlanFeatures - oldPlanFeatures)
                    );
                },
            };

            const newPeriodIndex = periods.indexOf(this.period);
            const oldPeriodIndex = periods.indexOf(currentPlanAction?.period);
            const newPlanPrice = this.getPrice(this.plan, this?.details, this.period);
            const oldPlanPrice =
                (this.currentPlan &&
                    currentPlanAction &&
                    this.getPrice(this.currentPlan, currentPlanAction.details, currentPlanAction.period)) ||
                0;

            let reasonText = "";
            if (currentPlanAction && planRules[this.plan.type] && !planRules[this.plan.type]()) {
                if (this.plan.type === "supsis") {
                    reasonText = "Mevcut temsilci sayısından düşük!";
                } else if (this.plan.type === "chatbot") {
                    reasonText = "Kullanılan session sayısı bu paketten yüksek!";
                } else {
                    reasonText = "Mevcut kanal sayısından düşük!";
                }
            } else if (currentPlanAction && newPeriodIndex < oldPeriodIndex) {
                reasonText = "Paketinizi alt döneme düşüremezsiniz.";
            } else if (currentPlanAction && newPeriodIndex >= oldPeriodIndex && newPlanPrice < oldPlanPrice) {
                reasonText = "Paketinizden düşük fiyata geçiş yapılamaz.";
            }

            return {
                enabled:
                    this.wizard ||
                    this.isAdmin ||
                    ((!currentPlanAction ||
                        (this.period === "monthly" && currentPlanAction.period === this.period) ||
                        currentPlanAction.period === "monthly" ||
                        (newPeriodIndex >= oldPeriodIndex && newPlanPrice > oldPlanPrice)) &&
                        (!planRules[this.plan.type] || planRules[this.plan.type]())),
                reasonText,
            };
        },
        isActive() {
            const plan = this.plan;
            const currentPlan = this.currentPlansHash[this.currentPlan?._id];
            return this.wizard
                ? this.isSelected
                : currentPlan &&
                      currentPlan.period === this.period &&
                      currentPlan.planId === plan._id &&
                      (plan.type !== "supsis" ||
                          plan?.isTeamPlan ||
                          currentPlan.details.agentCount === this.details.agentCount) &&
                      (plan.type !== "whatsapp" ||
                          currentPlan.details.whatsappChannel === this.details.whatsappChannel) &&
                      (plan.type !== "whatsapp-business" ||
                          currentPlan.details.whatsappChannel === this.details.whatsappChannel);
        },
        getPrice(plan, details, period) {
            let price = plan.price - (plan.price * plan.couponDiscount || 0) / 100;
            details = _.cloneDeep(details || { agentCount: 0, whatsappChannel: 0 });
            if (plan.type === "supsis" && plan?.isTeamPlan) {
                details.agentCount = 1;
            }
            const calculateDiscountPrice = (count, period = 1, discount = 0) => {
                return (price * count * period * (100 - discount)) / 100;
            };

            const discounts = {
                monthly: {
                    supsis: calculateDiscountPrice(details.agentCount),
                    whatsapp: calculateDiscountPrice(details.whatsappChannel),
                    "whatsapp-business": calculateDiscountPrice(details.whatsappChannel),
                    default: calculateDiscountPrice(1),
                },
                "monthly-3": {
                    supsis: calculateDiscountPrice(details.agentCount, 3, plan.threeMonthlyDiscount),
                    whatsapp: calculateDiscountPrice(details.whatsappChannel, 3, plan.threeMonthlyDiscount),
                    "whatsapp-business": calculateDiscountPrice(details.whatsappChannel, 3, plan.threeMonthlyDiscount),
                    default: calculateDiscountPrice(1, 3, plan.threeMonthlyDiscount),
                },
                "monthly-6": {
                    supsis: calculateDiscountPrice(details.agentCount, 6, plan.sixMonthlyDiscount),
                    whatsapp: calculateDiscountPrice(details.whatsappChannel, 6, plan.sixMonthlyDiscount),
                    "whatsapp-business": calculateDiscountPrice(details.whatsappChannel, 6, plan.sixMonthlyDiscount),
                    default: calculateDiscountPrice(1, 6, plan.sixMonthlyDiscount),
                },
                annual: {
                    supsis: calculateDiscountPrice(details.agentCount, 12, plan.yearlyDiscount),
                    whatsapp: calculateDiscountPrice(details.whatsappChannel, 12, plan.yearlyDiscount),
                    "whatsapp-business": calculateDiscountPrice(details.whatsappChannel, 12, plan.yearlyDiscount),
                    default: calculateDiscountPrice(1, 12, plan.yearlyDiscount),
                },
                forever: {
                    supsis: calculateDiscountPrice(details.agentCount),
                    whatsapp: calculateDiscountPrice(details.whatsappChannel),
                    "whatsapp-business": calculateDiscountPrice(details.whatsappChannel),
                    default: calculateDiscountPrice(1),
                },
            };

            price = plan.isAppsumo
                ? discounts["forever"][plan.type] || discounts["forever"].default
                : discounts[period][plan.type] || discounts[period].default;
            return ~~price;
        },
        getDiscount(value) {
            let price = value.isTrialPlan ? value.orjinalPrice : value.price;
            const details = _.cloneDeep(this.details || { agentCount: 0, whatsappChannel: 0 });
            if (value.type === "supsis" && value?.isTeamPlan) {
                details.agentCount = 1;
            }
            const discounts = {
                monthly: {
                    supsis: price * details.agentCount,
                    whatsapp: price * details.whatsappChannel,
                    "whatsapp-business": price * details.whatsappChannel,
                    default: price,
                },
                "monthly-3": {
                    supsis: price * details.agentCount * 3,
                    whatsapp: price * details.whatsappChannel * 3,
                    "whatsapp-business": price * details.whatsappChannel * 3,
                    default: price * 3,
                },
                "monthly-6": {
                    supsis: price * details.agentCount * 6,
                    whatsapp: price * details.whatsappChannel * 6,
                    "whatsapp-business": price * details.whatsappChannel * 6,
                    default: price * 6,
                },
                annual: {
                    supsis: price * details.agentCount * 12,
                    whatsapp: price * details.whatsappChannel * 12,
                    "whatsapp-business": price * details.whatsappChannel * 12,
                    default: price * 12,
                },
                forever: {
                    supsis: price * details.agentCount,
                    whatsapp: price * details.whatsappChannel,
                    "whatsapp-business": price * details.whatsappChannel,
                    default: price,
                },
            };

            price = discounts[this.period][this.plan.type] || discounts[this.period].default;

            return ~~price;
        },
        editPlan() {
            this.$emit("edit-action", this.plan);
        },
        deletePlan() {
            this.$emit("delete-action", this.plan);
        },
        applyCouponCode() {
            this.subscribe(this.plan);
        },
    },
    watch: {
        plans: {
            handler() {
                this.initData();
            },
            deep: true,
        },
        currentPlans: {
            handler() {
                this.initData();
            },
        },
    },
};
</script>

<style lang="scss" scoped>
$base-color: #ec4b1d;
$text-color: #171725;
.ant-card {
    border-radius: 20px;
}

@keyframes pullShadowAnimation {
    0% {
        -webkit-box-shadow: 0px 0px 10px -3px #ec4b1d;
        -moz-box-shadow: 0px 0px 10px -3px #ec4b1d;
        box-shadow: 0px 0px 10px -3px #ec4b1d;
    }
    50% {
        -webkit-box-shadow: 0px 0px 30px -3px #ec4b1d;
        -moz-box-shadow: 0px 0px 30px -3px #ec4b1d;
        box-shadow: 0px 0px 30px -3px #ec4b1d;
    }
    100% {
        -webkit-box-shadow: 0px 0px 10px -3px #ec4b1d;
        -moz-box-shadow: 0px 0px 10px -3px #ec4b1d;
        box-shadow: 0px 0px 10px -3px #ec4b1d;
    }
}
.supsis-plan {
    width: 270px;
    margin-top: 5px;
    position: relative;

    :first-child {
        margin-top: 0;
    }

    :last-child {
        margin-right: 0;
    }

    .editable-form {
        position: absolute;
        top: 10px;
        right: -18px;

        .form-button {
            font-size: 12px;
            border-radius: 100px;
            background: #ec4b1d;
            color: white;
            width: 40px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .delete-button {
            margin-top: 4px;
        }
    }

    .subscription-button {
        margin-top: 10px;
        width: 100%;
        border-radius: 10px;
        padding: 0.375rem 0.75rem;
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;
        background-color: #ec4b1d;
        color: #ffffff;
        cursor: pointer;

        &.selected {
            background-color: #ffffff;
            color: #696974;
            border: 1px solid #e2e2ea;
        }

        &.disabled {
            opacity: 0.5;
            cursor: no-drop;
            background-color: #ffffff;
            color: #696974;
            border: 1px solid #e2e2ea;
        }
    }
    .ant-card-body {
        .p-card-header {
            border-bottom: 1px solid #f1f1f5;
            display: flex;
            justify-content: space-between;
            position: relative;

            .p-card-tag {
                position: absolute;
                right: -8px;
                top: -13px;
            }

            .popular {
                color: #ffffff;
                background-color: $base-color;
                font-size: 12px;
                padding: 5px 8px;
                border-radius: 5px;
                float: right;
                font-family: Poppins;
                font-weight: 600;
                margin-top: 4px;
            }
        }

        .subtitle {
            font-family: Poppins;
            font-weight: 600;
            font-size: 22px;
            color: $text-color;

            &.top {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            &.setFont {
                font-size: 15px;
            }

            &.price {
                color: $text-color;
                font-size: 36px;
                margin-bottom: 0.5em;
                display: flex;
                align-items: baseline;
                &.setFontPrice {
                    font-size: 30px !important;
                }
                .discount {
                    text-decoration-line: line-through;
                    font-weight: 500;
                    font-size: 16px;
                    color: $base-color;
                    margin-left: 6px;
                }
                .oldprice {
                    font-weight: 500;
                    font-size: 16px;
                    color: $base-color;
                    margin-left: 6px;
                }
            }
        }

        .title {
            font-family: Roboto;
            font-weight: 700;
            font-size: 24px;
            color: $base-color;
        }

        .p-card-content {
            height: 300px;
            overflow-y: scroll;

            i {
                color: $base-color;
                padding-right: 5px;
            }

            p {
                font-size: 13px;
                margin-bottom: 1em;
                color: $text-color;

                &:first-child {
                    margin-top: 1em;
                }
            }

            &::-webkit-scrollbar {
                display: none;
            }

            &::-webkit-scrollbar-thumb {
                background: $base-color;
            }
        }

        button {
            margin-top: 10px;
            width: 100%;
            border-radius: 10px;
            background-color: $base-color;
            color: #ffffff;
            font-size: 14px;
            &.passive {
                cursor: not-allowed;
            }
            &.passive,
            &.selected {
                background-color: #ffffff;
                color: #696974;
                border: 1px solid #e2e2ea;
            }
        }
    }
}
.selected-plan {
    border: 2px solid #ec4b1d;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    .selected-plan-tag {
        color: #ffffff;
        background-color: $base-color;
        font-size: 13px;
        padding: 5px 8px;
        border-radius: 5px;
        font-family: Poppins;
        font-weight: 700;
        position: absolute;
        top: -10px;
        right: 20px;
        transform: translate(-50%, -50%);
        width: max-content;
    }
}
</style>
